import { useEffect } from "react"

import { useDispatch, useSelector } from "react-redux"

import { healthSetProp } from "../redux/health.slice"
import { getDefaultDataSource } from "../utils/getDefaultDataSource"

export const useHealthDefaultDataSource = ({ fetchedBA, currentBAId, requestedSource }) => {
  const dispatch = useDispatch()
  const { dataSource } = useSelector((state) => state.health)

  useEffect(() => {
    if (!fetchedBA || fetchedBA?.id !== currentBAId) return

    const connected = fetchedBA?.connected_payment_processors

    if (requestedSource && connected?.includes?.(requestedSource)) {
      if (dataSource !== requestedSource) {
        dispatch(healthSetProp({ key: "dataSource", value: requestedSource }))
      }
      return
    }

    if (connected?.includes?.(dataSource)) return
    const defaultDataSource = getDefaultDataSource(fetchedBA)
    dispatch(healthSetProp({ key: "dataSource", value: defaultDataSource }))
  }, [currentBAId, fetchedBA?.id, requestedSource])

  // Implementation if we need to preserve selected data source on page reload

  // const firstLoadingRef = useRef(true);
  // const [baSwitched, setBaSwitched] = useState(false);

  // useEffect(() => {
  //   if (firstLoadingRef.current) {
  //     firstLoadingRef.current = false;
  //     return;
  //   }
  //   setBaSwitched(true);
  // }, [currentBAId]);

  // useEffect(() => {
  //   if (!fetchedBA || fetchedBA?.id !== currentBAId || !baSwitched) return;
  //   setBaSwitched(false);
  //   const defaultDataSource = getDefaultDataSource(fetchedBA);
  //   dispatch(healthSetProp({ key: "dataSource", value: defaultDataSource }));
  // }, [currentBAId, fetchedBA?.id]);

  // useEffect(() => {
  //   if (!dataSource && fetchedBA) {
  //     const defaultDataSource = getDefaultDataSource(fetchedBA);
  //     dispatch(healthSetProp({ key: "dataSource", value: defaultDataSource }));
  //   }
  // }, [dataSource, fetchedBA]);
}
